import * as types from 'vuex-store/mutation-types'
import api from '../api'

export const toggleSidebar = ({ commit }, config) => {
  if (config instanceof Object) {
    commit(types.TOGGLE_SIDEBAR, config)
  }
}

export const toggleDevice = ({ commit }, device) => commit(types.TOGGLE_DEVICE, device)

export const expandMenu = ({ commit }, menuItem) => {
  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false
    commit(types.EXPAND_MENU, menuItem)
  }
}

export const switchEffect = ({ commit }, effectItem) => {
  if (effectItem) {
    commit(types.SWITCH_EFFECT, effectItem)
  }
}

export const triggerErrorNote = ({ commit }, msg) => commit(types.OPEN_NOTIFICATION, {
  type: 'danger',
  title: 'Error',
  message: msg || 'An error occured during the operation'
})

export const triggerSuccessNote = ({ commit }, msg) => commit(types.OPEN_NOTIFICATION, {
  type: 'success',
  title: 'Success',
  message: msg || 'The operation completed successfully'
})

export const triggerDataRefresh = ({ state }, payload) =>
  state.app.data_refresh_listeners.forEach((callback) => {
    callback(payload)
  })

export const lookup = ({ getters, dispatch }, payload) => {
  api.call({
    method: 'get',
    baseURL: getters.endpointUrl,
    url: payload.url,
    params: Object.assign({}, payload.params),
    access_token: getters['auth/token']
  })
  .then((res) => {
    if (payload.notify) {
      dispatch('triggerSuccessNote')
    }
    if (payload.callback) {
      payload.callback(res)
    }
  })
  .catch((err) => {
    if (payload.notify) {
      dispatch('triggerErrorNote', err.response.data.message)
    }
    if (payload.failure) {
      payload.failure(err)
    }
  })
}

export const upsert = ({ getters, dispatch }, payload) => {
  let method = payload.method || 'post'
  method = method.toLowerCase()
  let data = null
  let params = null
  if (method === 'post' || method === 'put') {
    data = payload.data
  } else {
    params = payload.data
  }
  api.call({
    method,
    baseURL: getters.endpointUrl,
    url: payload.url,
    data,
    params,
    access_token: getters['auth/token']
  })
  .then((res) => {
    if (payload.notify) {
      dispatch('triggerSuccessNote')
    }
    if (payload.callback) {
      payload.callback(res)
    }
  })
  .catch((err) => {
    if (payload.notify) {
      dispatch('triggerErrorNote', err.response.data.message)
    }
    if (payload.failure) {
      payload.failure(err)
    }
  })
}

export const del = ({ getters, dispatch }, payload) => {
  api.call({
    method: 'delete',
    baseURL: getters.endpointUrl,
    url: payload.url,
    params: payload.params || payload.data,
    access_token: getters['auth/token']
  })
  .then((res) => {
    if (payload.notify) {
      dispatch('triggerSuccessNote')
    }
    if (payload.callback) {
      payload.callback(res)
    }
  })
  .catch((err) => {
    if (payload.notify) {
      dispatch('triggerErrorNote', err.response.data.message)
    }
    if (payload.failure) {
      payload.failure(err)
    }
  })
}



// WEBPACK FOOTER //
// ./client/store/actions.js